module.exports = __webpack_public_path__ + "img/C07TechChiefChampion_ua.26bcda92.webp";